module.exports = __webpack_public_path__ + "static/media/uk.46c09c48.webp";